module.exports = __webpack_public_path__ + "img/11.4875c25b.jpg";